import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";
import type { CardResponseDto, S3DocumentDto } from "@src/api-new/generated-api.schemas";


interface FinancialInfoState {
  cards?: CardResponseDto[],
  creditLimit?: any,
  hasSeenFtbNotification: boolean,
  docsLoading?: boolean,
  copyOfCardDocs?: S3DocumentDto[]
}

const initialState: FinancialInfoState = {
  hasSeenFtbNotification: false
};

const financialInfoSlice = createSlice({
  name: "financialInfo",
  initialState,
  reducers: {
    getCards(state, action: PayloadAction<CardResponseDto[]>) {
      state.cards = action.payload;
    },
    getCreditLimitSuccess(state, action: PayloadAction<any>) {
      state.creditLimit = action.payload;
    },
    setHasSeenFtbNotification(state, action: PayloadAction<boolean>) {
      state.hasSeenFtbNotification = action.payload;
    },
    setCardAsActive(state, action: PayloadAction<string>) {
      return state;
    },
    getDocumentsRequest(state) {
      state.docsLoading = true;
    },
    getDocumentsSuccess(state, action: PayloadAction<any>) {
      state.docsLoading = false;
      state.copyOfCardDocs = action.payload;
    },
    getDocumentsFailure(state, action: PayloadAction<any>) {
      state.docsLoading = false;
      state.copyOfCardDocs = [];
    },
    destroy() {
      return initialState;
    }
  }
});


export default financialInfoSlice.reducer;
export const {
  getCards,
  getCreditLimitSuccess,
  setHasSeenFtbNotification,
  setCardAsActive,
  destroy
} = financialInfoSlice.actions;
export const financialInfoActions = financialInfoSlice.actions;
